import styles from './AffectioCard.module.sass'
import Image from "next/image";
import cn from "classnames";
import CardLevelAndName from "@/components/Cards/CardLevelAndName";
import CardAttacks from "@/components/Cards/CardAttacks";
import CardFooter from "@/components/Cards/CardFooter";
import {useGameContext} from "@/context/GameContext";

const AffectioCard = ({
	                      cardIndex,
	                      card,
	                      className,
	                      currentCardIndex,
	                      setCurrentCardIndex,
	                      ...props}) => {

	const {isMobile} = useGameContext()

	return (
			<div className={cn(
					styles.affectio_card,
					className,
					card.className,
					'gsap-cards',
					{['basic_pointer']: cardIndex === 1},
					{['custom_pointer']: cardIndex !== 1},
					)}
			     onClick={() => {setCurrentCardIndex(cardIndex)}}
			     {...props}>
				{/*region Image Background*/}
				<Image
						className={styles.image_background}
						src={card.background.src}
						alt={card.background.alt}
						width={522} height={383}
				/>
				{/*endregion*/}

				{/*Info*/}
				<CardLevelAndName level={card.level} name={card.name}/>

				{/*region Hearts*/}
				<div className={styles.hearts}>
					<span className={styles.pv}>PV:</span>
					{[...Array(card.hearts)].map((_, index) => {
						return (
								<Image
										key={index}
										src={'/images/Cards/heart.png'}
										alt={'Heart'}
										width={128}
										height={128}
								/>
						)
					})}
				</div>
				{/*endregion*/}

				{/*region Character*/}
				{isMobile ? <Image
								className={cn(styles.character, card.character.className)}
								src={card.character.mobileSrc}
								alt={card.character.alt}
								width={card.character.width}
								height={card.character.height}
								unoptimized={true}
						/>
						: <Image
						className={cn(styles.character, card.character.className)}
						src={card.character.src}
						alt={card.character.alt}
						width={card.character.width}
						height={card.character.height}
				/>}
				{/*endregion*/}

				{/*Dark Background*/}
				<div className={styles.background}/>
				<div className={styles.separator}/>

				{/*Attacks*/}
				<CardAttacks attacks={card.attacks}/>

				{/*Objects*/}
				{card.objects &&
						<div className={styles.objects}>
						<span>Objets:</span>
							{card.objects.map((object, index) => {
							return (
									<Image key={index} src={object.src} alt={object.alt} width={145} height={144}/>
							)
						})}
					</div>
				}


				{/*Footer*/}
				<CardFooter cardNumber={card.cardNumber}/>
			</div>
	);
}
export default AffectioCard;